var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { "padding-bottom": "70px" } },
    [
      _c(
        "keep-alive",
        [
          _vm.$route.meta.keepAlive
            ? _c("router-view", {
                on: {
                  change_title: function ($event) {
                    return _vm.change_title($event)
                  },
                  showBack: _vm.showBack,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      !_vm.$route.meta.keepAlive
        ? _c("router-view", {
            on: {
              change_title: function ($event) {
                return _vm.change_title($event)
              },
              showBack: _vm.showBack,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }